import { render, staticRenderFns } from "./echartsBox.vue?vue&type=template&id=4be990ac&scoped=true"
import script from "./echartsBox.vue?vue&type=script&lang=js"
export * from "./echartsBox.vue?vue&type=script&lang=js"
import style0 from "./echartsBox.vue?vue&type=style&index=0&id=4be990ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be990ac",
  null
  
)

export default component.exports